import React from 'react';
import { PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';
import './Chart.css';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF', '#41B2FF'];

const PieChartRechart = ({ data, title, height = 200, labelMap = {}, labelFormatter,dataKey = "value", nameKey = "type",  }) => {
  const chartWidth = 300; 
  const chartHeight = height; 
  const outerRadius = 70;

  const getLabel = (type) => {
    return labelMap[type] || type;
  }; 
  return (
    <div className="pieChartWrapper">
      <PieChart width={chartWidth} height={chartHeight}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          outerRadius={outerRadius}
          fill="#8884d8"
          dataKey={dataKey}
          nameKey={nameKey}
          
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend layout="vertical" align="right" verticalAlign="middle" formatter={(value, entry, index) => getLabel(value)} wrapperStyle={{ paddingLeft: 20 }}/>
      </PieChart>
      <h2 style={{textAlign:'center'}}>{title}</h2>
    </div>
  );
};

export default PieChartRechart;